import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Modal, Input, notification } from "antd";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaEdit,
  FaTrash,
} from "react-icons/fa";
import { MdAdminPanelSettings, MdSubscriptions } from "react-icons/md";
import { Card, Button } from "antd";
import { PiDotsThreeBold, PiContactlessPaymentFill } from "react-icons/pi";
import { IoIosTime } from "react-icons/io";
import { FaCrown } from "react-icons/fa";
import RemainingDays from "../components/Charts/RemainingDays";
import TrancationTable from "../components/Leads/TrancationTable";
import { GoStack } from "react-icons/go";
import Avatar from "@mui/material/Avatar";
import { Link, useNavigate } from "react-router-dom";
import { FaMagnifyingGlassLocation } from "react-icons/fa6";
import { baseURL } from "../store/api/axios";
import { encryptdata } from "../utils/encryptDecrypt";
import { useMediaQuery } from "react-responsive";

const MyProfile = () => {
  const [profileData, setProfileData] = useState(null);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reload, setReload] = useState(false);
  const userID = localStorage.getItem("userId");
  const accessToken = localStorage.getItem("accessToken");
  const Domain = localStorage.getItem("domain");

  const [formData, setFormData] = useState({
    name: "",
    mobileNo: "",
    location: "",
  });

  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 576 });

  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);

  const [projectPhotos, setProjectPhotos] = useState(null);
  const [previewProjectPhotos, setPreviewProjectPhotos] = useState("");

  const [brochureUpload, setBrochureUpload] = useState([]);
  const [previewBrochureUpload, setPreviewBrochureUpload] = useState([]);

  const [existingProjectPhoto, setExistingProjectPhoto] = useState("");
  const [existingBrochures, setExistingBrochures] = useState([]);

  const fileInputRef = React.useRef(null);
  const brochureInputRef = React.useRef(null);

  // useEffect(() => {
  //   // Check if this is the first time the page is being loaded
  //   if (sessionStorage.getItem("hasVisitedProfile") !== "true") {
  //     // Set sessionStorage to mark that the user has visited the page
  //     sessionStorage.setItem("hasVisitedProfile", "true");
  //     // Trigger a page refresh
  //     setTimeout(() => {
  //       window.location.reload();
  //     }, 1000);
  //   }
  // }, []);

  const fetchMyProfile = async () => {
    try {
      // const encrypt = encryptdata({userID})
      const response = await fetch(`${baseURL}user/profile-business/${userID}`);
      if (!response.ok) {
        throw new Error("Failed to get user profile");
      }
      const responseData = await response.json();
      const businessProfile = responseData.businessprofile.businesses[0];
      if (!businessProfile) return;

      localStorage.setItem("name", businessProfile.name);
      localStorage.setItem("mobileNo", businessProfile.mobileNo);
      localStorage.setItem("location", businessProfile.location);
      setFormData({
        name: businessProfile.name || "",
        mobileNo: businessProfile.mobileNo || "",
        location: businessProfile.location || "",
      });
      setProfileData(responseData.businessprofile);
    } catch (error) {
      setError(error.message);
      console.error("Error fetching profile:", error);
    }
  };

  const fetchSubscription = async () => {
    try {
      const encrypt = encryptdata({ userID });
      const response = await fetch(
        `${baseURL}masters/usersubscription/latestuserplan/${userID}`,
      );
      if (!response.ok) {
        throw new Error("Failed to get subscription plan");
      }
      const subResponse = await response.json();
      setSubscriptionData(subResponse.data);
      const planamount =
        subResponse.data.subscriptionplan?.Subscriptiondetails?.monthAmount ||
        0;
      const provinceId = subResponse.data.subscriptionplan?.provinceId || [];

      localStorage.setItem("provinceid", JSON.stringify(provinceId));
      localStorage.setItem("subscriptionamount", planamount);
    } catch (error) {
      setError(error.message);
      console.error("Error fetching subscription:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleOk = async () => {
     const indianPhoneRegex = /^(?:\+91|91)?[6-9]\d{9}$/;

          if (!formData.name.trim()) {
    notification.error({ message: "Name cannot be empty" });
    return;
  }

  if (!formData.mobileNo.trim()) {
    notification.error({ message: "Mobile number cannot be empty" });
    return;
  }

    if (!indianPhoneRegex.test(formData.mobileNo)) {
    notification.error({
      message:
        "Enter a valid Indian mobile number (e.g., 9876543210)",
    });
    return;
  }

  // Normalize the mobile number to 10 digits (remove +91 or 91 if present)
  // const normalizedMobile = formData.mobileNo.replace(/^(\+91|91)/, "");


  if (!formData.location.trim()) {
    notification.error({ message: "Location cannot be empty" });
    return;
  }
    const apiUrl = `${baseURL}user/updateprofile/${userID}`;

    try {
      const formDataToSend = new FormData();

      // 1. Append Text Fields
      formDataToSend.append("name", formData.name);
      formDataToSend.append("mobileNo", formData.mobileNo);
      formDataToSend.append("location", formData.location);

      // We send only the brochures currently in 'existingBrochures' state
      if (existingBrochures.length > 0) {
        existingBrochures.forEach((url) => {
          formDataToSend.append("existingBrochures", url);
        });
      } else {
        // If user deleted all existing ones, tell the backend
        formDataToSend.append("brochureCreatives", null);
      }

      // Append new files
      brochureUpload.forEach((file) => {
        formDataToSend.append("brochureCreatives", file);
      });

      // 3. Handle Project Photo
      if (projectPhotos instanceof File) {
        formDataToSend.append("projectPhoto", projectPhotos);
      } else if (existingProjectPhoto) {
        formDataToSend.append("existingProjectPhoto", existingProjectPhoto);
      } else {
        formDataToSend.append("projectPhoto", "null");
      }

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          Authorization: `${accessToken}`,
        },
        body: formDataToSend,
      });

      const result = await response.json();

      if (response.ok) {
        notification.success({
          message: "Success",
          description: "Profile updated successfully",
        });

        // Update UI state immediately
        setProfileData((prev) => {
          if (!prev) return prev;
          const updated = { ...prev };
          const updatedBusiness = { ...updated.businesses[0] };

          updatedBusiness.name = formData.name;
          updatedBusiness.mobileNo = formData.mobileNo;
          updatedBusiness.location = formData.location;

          // Sync Photo
          const photoFromSrv = result.updateData?.projectPhoto;
          updatedBusiness.projectPhoto =
            photoFromSrv === "null" || !photoFromSrv
              ? projectPhotos
                ? URL.createObjectURL(projectPhotos)
                : ""
              : photoFromSrv;

          // Use the existingBrochures state that was just submitted
          // combined with any new uploads the server processed
          // ... inside setProfileData ...
          const srvBrochures = result.updateData?.existingBrochures || [];
// Clean the array immediately
const cleanBrochures = Array.isArray(srvBrochures) 
    ? srvBrochures.filter(item => item !== "null" && item !== "")
    : [];

setExistingBrochures(cleanBrochures);

         

          updated.businesses[0] = updatedBusiness;
          return updated;
        });

        // Sync LocalStorage
        localStorage.setItem("name", formData.name);
        localStorage.setItem("mobileNo", formData.mobileNo);
        localStorage.setItem("location", formData.location);

        // ✅ RESET TEMPORARY MODAL STATES
        setBrochureUpload([]);
        setPreviewBrochureUpload([]);
        setProjectPhotos(null);
        setPreviewProjectPhotos("");

        setIsModalOpen(false);

        // Force a fresh fetch to ensure server & client are 100% identical
        fetchMyProfile();
      } else {
        throw new Error("Failed to update profile");
      }
    } catch (error) {
      console.error("Update error:", error);
      notification.error({ message: "Error", description: "Update failed" });
    }
  };
  // const handleOk = async () => {
  //   const apiUrl = `${baseURL}user/updateprofile/${userID}`;

  //   try {
  //     // Encrypt text fields
  //     const encryptFields = encryptdata(formData);

  //     const formDataToSend = new FormData();

  //     // ✅ plain values (NO encryption)
  //     formDataToSend.append("name", formData.name);
  //     formDataToSend.append("mobileNo", formData.mobileNo);
  //     formDataToSend.append("location", formData.location);

  //     // ✅ handle existing brochures
  //     // ✅ handle existing brochures
  //     if (existingBrochures.length > 0) {
  //       existingBrochures.forEach((url) => {
  //         formDataToSend.append("existingBrochures", url);
  //       });
  //     } else {
  //       // 🔥 THIS LINE FIXES YOUR ISSUE
  //       formDataToSend.append("existingBrochures", "null");
  //     }
  //     // existingBrochures.forEach((url) => {
  //     //   formDataToSend.append("existingBrochures", url);
  //     // });
  //     // ✅ files
  //     brochureUpload.forEach((file) => {
  //       formDataToSend.append("brochureCreatives", file);
  //     });

  //     // Add project photo if available
  //     // if (projectPhotos) {
  //     //   formDataToSend.append("projectPhoto", projectPhotos);
  //     // }
  //     // if (projectPhotos) {
  //     //   formDataToSend.append("projectPhoto", projectPhotos);
  //     // } else if (!existingProjectPhoto) {
  //     //   // 🔥 user deleted existing photo
  //     //   formDataToSend.append("projectPhoto", "null");
  //     // }

  //     // NEW FILE
  //     if (projectPhotos instanceof File) {
  //       formDataToSend.append("projectPhoto", projectPhotos);
  //     }

  //     // KEEP OLD IMAGE
  //    else if (existingProjectPhoto) {
  //  formDataToSend.append("existingProjectPhoto", existingProjectPhoto);
  //   }

  //     // DELETE IMAGE
  //     else {
  //       formDataToSend.append("projectPhoto", "null");
  //     }
  //     const response = await fetch(apiUrl, {
  //       method: "PUT",

  //       headers: {
  //         Authorization: `${accessToken}`, // do NOT set Content-Type; browser sets it automatically for FormData
  //       },
  //       body: formDataToSend,
  //     });

  //     const result = await response.json();
  //     if (response.ok) {
  //       notification.success({
  //         message: "Success",
  //         description: "Profile updated",
  //       });

  //       // ✅ update UI instantly
  //       setProfileData((prev) => {
  //         const updated = { ...prev };
  //         updated.businesses[0] = {
  //           ...updated.businesses[0],

  //           name: result.updateData.name,
  //           mobileNo: result.updateData.mobileNo,
  //           location: formData.location,

  //           // ✅ FIX PHOTO
  //           projectPhoto:
  //             result.updateData.projectPhoto === "null"
  //               ? ""
  //               : result.updateData.projectPhoto || "",

  //           // ✅ FIX BROCHURE
  //           brochureCreatives:
  //             result.updateData.existingBrochures === "null"
  //               ? []
  //               : result.updateData.existingBrochures
  //                 ? [result.updateData.existingBrochures]
  //                 : updated.businesses[0].brochureCreatives,
  //         };
  //         return updated;
  //       });
  //       const updatedProjectPhoto =
  //  result.updateData.projectPhoto === "null"
  //   ? ""
  //   : result.updateData.projectPhoto || "";

  //   setExistingProjectPhoto(updatedProjectPhoto);

  //       // ✅ keep localStorage in sync
  //       localStorage.setItem("name", formData.name);
  //       localStorage.setItem("mobileNo", formData.mobileNo);
  //       localStorage.setItem("location", formData.location);

  //       // fetchMyProfile(); // refresh data
  //     } else {
  //       notification.error({
  //         message: "Error",
  //         description: "Update failed",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error while updating profile:", error);
  //   }

  //   setIsModalOpen(false);
  // };

  useEffect(() => {
    let name = localStorage.getItem("name") || "";
    let mobileNo = localStorage.getItem("mobileNo") || "";
    let location = localStorage.getItem("location") || "";

    fetchMyProfile();
    fetchSubscription();

    setFormData({ name, mobileNo, location });
  }, []);

  const availableAmount = profileData?.AvailableAmount || 0;
  const creditpoints = profileData?.OutofAmount || 0;
  // const creditpoints = subscriptionData?.subscriptionplan?.Subscriptiondetails?.creditpoints || 0;

  if (!profileData) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div className="loaderMain"></div>
      </div>
    );
  }

  const showModal = () => {
    const business = profileData?.businesses?.[0];

    // setExistingProjectPhoto(business?.projectPhoto || "");
    setExistingProjectPhoto(
      business?.projectPhoto && business?.projectPhoto !== "null"
        ? business.projectPhoto
        : "",
    );
    // setExistingBrochures(business?.brochureCreatives || []);
    setExistingBrochures(
      Array.isArray(business?.brochureCreatives)
        ? business.brochureCreatives
        : [],
    );

    setProjectPhotos(null);
    setPreviewProjectPhotos("");
    setBrochureUpload([]);
    setPreviewBrochureUpload([]);

    setIsModalOpen(true);
  };

  const handleProjectPhotosChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setProjectPhotos(file);
      setPreviewProjectPhotos(URL.createObjectURL(file));
      setExistingProjectPhoto(""); // remove old
    }
  };

  const handleBrochureUploadChange = (e) => {
    const files = Array.from(e.target.files);

    setBrochureUpload((prev) => {
      const updated = [...prev, ...files].slice(0, 10);
      return updated;
    });

    const previews = files.map((file) => URL.createObjectURL(file));
    setPreviewBrochureUpload((prev) => {
      const updated = [...prev, ...previews].slice(0, 10);
      return updated;
    });
    e.target.value = "";
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  const handleBrochuresDownload = (brochureUrls = []) => {
    if (!Array.isArray(brochureUrls) || brochureUrls.length === 0) return;

    brochureUrls.forEach((url) => {
      if (!url) return;
      const fixedUrl =
        url.startsWith("http://") || url.startsWith("https://")
          ? url
          : `https://${url}`;

      const link = document.createElement("a");
      link.href = fixedUrl;
      link.download = fixedUrl.split("/").pop(); // Set file name from URL
      link.target = "_blank"; // Open/download in new tab
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const handleDownload = (photoUrl) => {
    if (!photoUrl) return;
    const fixedUrl =
      photoUrl.startsWith("http://") || photoUrl.startsWith("https://")
        ? photoUrl
        : `https://${photoUrl}`;

    // Create a temporary invisible <a> tag to trigger download
    const link = document.createElement("a");
    link.href = fixedUrl;
    link.download = fixedUrl.split("/").pop(); // Sets the filename
    link.target = "_blank"; // Opens in new tab
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Cleanup
  };

  const isImage = (url) => {
    return /\.(jpg|jpeg|png|webp|gif)$/i.test(url);
  };

  return (
    <div>
      <Row>
        <Col xs={12} md={4}>
          <div className="profile-card">
            <div className="profile-header">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "150px",
                  backgroundColor: "#8A9CFF",
                  borderRadius: "10px",
                }}
              >
                <Avatar
                  style={{
                    width: "100px",
                    height: "100px",
                    border: "3px solid #ffffff",
                    marginBottom: "10px",
                    borderRadius: "50%",
                  }}
                >
                  {" "}
                  {profileData.businesses?.[0]?.companyName
                    ?.charAt(0)
                    .toUpperCase()}{" "}
                </Avatar>
              </div>

              <button onClick={showModal} className="edit-button">
                <FaEdit />
              </button>
            </div>

            <h2 className="profile-name">
              {profileData.businesses?.[0]?.companyName || "No Company Name"}
            </h2>
            <p className="profile-birthday">
              {/* {Domain} */}
              {/* {new Date(
                profileData.businesses?.[0]?.startDate
              ).toLocaleDateString() || "N/A"} */}
            </p>
            <hr />

            <div className="profile-details">
              <p className="mb-3">
                <MdAdminPanelSettings size={20} className="icon" />{" "}
                {profileData.businesses?.[0]?.name || "No name"}
              </p>
              <p className="mb-3">
                <FaEnvelope className="icon" />{" "}
                {profileData.businesses?.[0]?.email || "No email"}
              </p>
              <p className="mb-3">
                <FaPhoneAlt className="icon" />
                {profileData.businesses?.[0]?.mobileNo || "No number"}
              </p>
              <p className="mb-3">
                <FaMapMarkerAlt className="icon" />{" "}
                {profileData.businesses?.[0]?.location || "No location"}
              </p>
            </div>
            <hr />
            <div className="profile-details">
              <p className="mb-3">
                <FaMagnifyingGlassLocation className="icon" />{" "}
                <strong>Preferred location:</strong>{" "}
                {/* {subscriptionData?.subscriptionplan?.Subscriptiondetails?.title || ""} */}
                {profileData.businesses?.[0]?.locationNames?.length > 0 ? (
                  <ul>
                    {profileData.businesses[0].locationNames.map(
                      (location, index) => (
                        <li key={index}>{location}</li>
                      ),
                    )}
                  </ul>
                ) : (
                  "No location"
                )}
              </p>
              <p className="mb-3">
                <IoIosTime className="icon" /> <strong>Credits allotted</strong>{" "}
                : {creditpoints}
              </p>
              <p className="mb-3">
                <PiContactlessPaymentFill className="icon" />{" "}
                <strong>Payment method</strong> : Net Banking
              </p>
            </div>
          </div>
        </Col>

        <Col xs={12} md={8} className="mt-3 mt-md-0">
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: isMobile ? "column" : "row",
                gap: "16px",
              }}
            >
              <Card
                title="Subscription"
                extra={<PiDotsThreeBold size={20} />}
                style={{ width: "100%" }}
              >
                <div className="premium-container">
                  <div className="premium-text">
                    <h5 className="premium-title">
                      <FaCrown className="crown-icon" />
                      {subscriptionData?.subscriptionplan?.Subscriptiondetails
                        ?.title === "Custom Subscription"
                        ? "Custom"
                        : subscriptionData?.subscriptionplan
                            ?.Subscriptiondetails?.title || "Custom"}
                    </h5>
                    <span className="monthly-plan">
                      {subscriptionData?.subscriptionplan?.Subscriptiondetails
                        ?.title || "N/A"}
                    </span>
                  </div>
                  <Button
                    color="primary"
                    variant="outlined"
                    onClick={handleOpen}
                  >
                    Upgrade Plan
                  </Button>
                  <Modal
                    open={show}
                    onCancel={handleClose}
                    title="Upgrade Subscription"
                    centered
                    footer={[
                      <Button
                        key="upgrade"
                        type="primary"
                        onClick={() => navigate("/upgrade-plan")}
                      >
                        Continue Upgrade
                      </Button>,
                      <Button
                        key="update"
                        onClick={() => navigate("/subscription-profile-update")}
                      >
                        Update Profile First
                      </Button>,
                    ]}
                  >
                    Continue with upgrade plan or update your profile details
                    first?
                  </Modal>
                </div>
                <div className="mt-2">
                  <p className="mb-0">
                    Active on{" "}
                    {formatDate(
                      subscriptionData?.subscriptionplan?.subscriptionDate ||
                        "DD-MM-YYYY",
                    )}
                  </p>
                  <span style={{ color: "#747474", fontSize: "smaller" }}>
                    We will send you a notification upon credits expiry
                  </span>
                  <p className="mb-0 mt-3">
                    <GoStack /> {creditpoints} Credits allotted
                  </p>
                  <span style={{ color: "#747474", fontSize: "smaller" }}>
                    Extend your Pro package to 1,000+ leads
                  </span>
                </div>
              </Card>
              <Card
                title="Credits Remaining"
                extra={<PiDotsThreeBold size={20} />}
                style={{ width: "100%" }}
              >
                <RemainingDays
                  creditpoints={creditpoints}
                  availableAmount={availableAmount}
                />
              </Card>
            </div>
          </div>

          <div className="mt-3">
            <Card title="Subscription transaction history">
              <div
                style={{
                  overflowX: "auto",
                  width: "100%",
                }}
              >
                <div style={{ minWidth: "700px" }}>
                  <TrancationTable />
                </div>
              </div>
            </Card>
          </div>
        </Col>
        <Modal
          title="Edit profile"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <Input
            name="name"
            placeholder="Enter Name"
            value={formData.name}
            onChange={handleInputChange}
            style={{ marginTop: "15px" }}
          />
          <Input
            name="mobileNo"
            placeholder="Mobile Number"
            value={formData.mobileNo}
            onChange={handleInputChange}
            style={{ marginTop: "15px" }}
          />
          <Input
            name="location"
            placeholder="Location"
            value={formData.location}
            onChange={handleInputChange}
            style={{ marginTop: "15px" }}
          />
          <Row>
            <Col md={6}>
              <div className="mt-4">
                <p style={{ color: "#5e5e5e" }}>Project Image</p>

                <input
                  type="file"
                  accept="image/*"
                  onChange={handleProjectPhotosChange}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  id="edit-project-photo"
                />

                <label htmlFor="edit-project-photo" style={styles.uploadBtn}>
                  Upload Image
                </label>
                 <p style={{ fontSize: "12px", color: "#888", marginTop: "2px", marginLeft:"4px" }}>
     Maximum file size: 20 MB
    </p>

                {/* Existing Image */}
                {/* {existingProjectPhoto &&
                  existingProjectPhoto !== "null" &&
                  !projectPhotos && (
                    <div style={styles.previewBox}>
                      <img
                        src={existingProjectPhoto}
                        style={styles.imageThumb}
                      />
                      <span style={styles.fileName}>Existing Image</span>
                      <FaTrash
                        style={styles.deleteIcon}
                        onClick={() => setExistingProjectPhoto("")}
                      />
                    </div>
                  )} */}

                {/* New Image */}
                {/* Project Image Preview */}
                {(previewProjectPhotos || existingProjectPhoto) && (
                  <div style={styles.previewBox}>
                    <img
                      src={previewProjectPhotos || existingProjectPhoto}
                      style={styles.imageThumb}
                    />
                    <span style={styles.fileName}>
                      {projectPhotos?.name || "Existing Image"}
                    </span>
                    <FaTrash
                      style={styles.deleteIcon}
                      onClick={() => {
                        setProjectPhotos(null);
                        setPreviewProjectPhotos("");
                        setExistingProjectPhoto("");
                        fileInputRef.current.value = "";
                      }}
                    />
                  </div>
                )}
              </div>
            </Col>
            <Col md={6}>
              <div className="mt-4">
                <p style={{ color: "#5e5e5e" }}>Brochures</p>

                <input
                  type="file"
                  multiple
                  accept="image/*,application/pdf"
                  onChange={handleBrochureUploadChange}
                  ref={brochureInputRef}
                  style={{ display: "none" }}
                  id="edit-brochure"
                />

                <label htmlFor="edit-brochure" style={styles.uploadBtn}>
                  Upload Brochures
                </label>
                         <p style={{ fontSize: "12px", color: "#888", marginTop: "2px", marginLeft:"4px" }}>
     Maximum file size: 20 MB
    </p>

                {/* Existing */}
                {/* {existingBrochures.map((url, index) => (
                  <div key={index} style={styles.previewBox}>
                    <img src="/pdf-icon.png" style={styles.imageThumb} />
                    <span style={styles.fileName}>Existing File</span>
                    <FaTrash
                      style={styles.deleteIcon}
                      onClick={() => {
                        const updated = [...existingBrochures];
                        updated.splice(index, 1);
                        setExistingBrochures(updated);
                      }}
                    />
                  </div>
                ))} */}

                {Array.isArray(existingBrochures) &&
                  existingBrochures.filter(
                    (url) => url !== "null" && url !== "",
                  ).length > 0 &&
                  existingBrochures
                    .filter((url) => url !== "null" && url !== "")
                    .map((url, index) => {
                      const image = isImage(url);

                      return (
                        <div key={index} style={styles.previewBox}>
                          {image ? (
                            <img src={url} style={styles.imageThumb} />
                          ) : (
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                              style={styles.imageThumb}
                            />
                          )}

                          <span style={styles.fileName}>
                            {url.split("/").pop()}
                          </span>

                          <FaTrash
                            style={styles.deleteIcon}
                            onClick={() => {
                              const updated = [...existingBrochures];
                              updated.splice(index, 1);
                              setExistingBrochures(updated);
                            }}
                          />
                        </div>
                      );
                    })}

                {/* New */}
                {previewBrochureUpload.map((url, index) => (
                  <div key={index} style={styles.previewBox}>
                    <img src={url} style={styles.imageThumb} />
                    <span style={styles.fileName}>
                      {brochureUpload[index]?.name}
                    </span>
                    <FaTrash
                      style={styles.deleteIcon}
                      onClick={() => {
                        const files = [...brochureUpload];
                        const previews = [...previewBrochureUpload];

                        files.splice(index, 1);
                        previews.splice(index, 1);

                        setBrochureUpload(files);
                        setPreviewBrochureUpload(previews);

                        if (files.length === 0) {
                          brochureInputRef.current.value = "";
                        }
                      }}
                    />
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Modal>
      </Row>
    </div>
  );
};

const styles = {
  cardContainer: {
    padding: "20px",
    borderRadius: "8px",
    maxWidth: "600px",
    margin: "0px auto",
    textAlign: "start",
    fontFamily: "Arial, sans-serif",
  },
  quote: {
    fontSize: "25px",
    color: "#333",
    marginBottom: "20px",
  },
  author: {
    fontSize: "16px",
    color: "#555",
    fontWeight: "bold",
  },
  position: {
    fontSize: "14px",
    color: "#777",
  },

  uploadBtn: {
    display: "inline-block",
    padding: "10px 18px",
    backgroundColor: "#ffff",
    color: "#1F1F1F",
    border: "1px solid #D9D9D9",
    borderRadius: "6px",
    cursor: "pointer",
    marginBottom: "5px",
  },
  previewBox: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "10px",
    maxWidth: "400px",
    gap: "12px",
    backgroundColor: "#f9f9f9",
    marginTop: "10px",
  },
  imageThumb: {
    width: "40px",
    height: "40px",
    objectFit: "cover",
    borderRadius: "4px",
  },
  fileName: {
    flex: 1,
    color: "#1a73e8",
    fontSize: "14px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  deleteIcon: {
    color: "#888",
    cursor: "pointer",
    fontSize: "16px",
  },
};

export default MyProfile;

// import React, { useEffect, useState } from 'react'
// import {Row,Col} from 'react-bootstrap';
// import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaEdit } from "react-icons/fa";
// import { MdAdminPanelSettings,MdOutlinePeople,MdSubscriptions } from "react-icons/md";
// import {Card} from 'antd'
// import { PiDotsThreeBold,PiContactlessPaymentFill } from "react-icons/pi";
// import { IoIosTime } from "react-icons/io";
// import { FaCrown } from "react-icons/fa";
// import RemainingDays from "../components/Charts/RemainingDays";
// import {Button} from 'antd';
// import TrancationTable from '../components/Leads/TrancationTable';

// const MyProfile = () => {

//   const [profileData, setProfileData] = useState(null);
//   const [subscriptionData, setSubscriptionData] = useState(null)
//   const [error, setError] = useState(null)
//   const userID = localStorage.getItem('userId')

//   const fetchMyProfile = async ()=>{
//     try {
// const encrypt = encryptdata({userID})
//       const response = await fetch(`${baseURL}user/profile-business/${encrypt}`)
//       if(!response.ok){
//         throw new Error('Failed to get user profile')
//       }
//       const responseData = await response.json()
//       setProfileData(responseData.businessprofile)
//     } catch (error) {
//       setError(error.message)
//       console.error('Error fetching profile:', error);
//     }
//   }

//   const fetchSubscription = async ()=>{
//     try {
// const encrypt = encryptdata({userID})
//       const response = await fetch (`${baseURL}masters/usersubscription/latestuserplan/${encrypt}`)
//       if(!response.ok){
//         throw new Error('Failed to get user profile')
//       }
//       const subResponse = await response.json()
//       setSubscriptionData(subResponse.data)
//     } catch (error) {
//       setError(error.message)
//       console.error('Error fetching subscription:', error);
//     }
//   }

//   useEffect(()=>{
//     fetchMyProfile()
//     fetchSubscription()
//   },[])

//   const { AvailableAmount } = profileData || {};
//   const creditpoints = subscriptionData.subscriptionplan?.creditpoints || 0;

//   if (!profileData) {
//     return <p>Loading...</p>;
//   }

//   if (!subscriptionData || !subscriptionData.subscriptionplan) {
//     return <p>No subscription data available.</p>; // Handle cases where `subscriptionData` is missing or malformed
//   }

//   return (
//     <div>
//        <Row>
//         <Col md={4}>
//            <div>
//            <div className="profile-card">
//       <div className="profile-header">
//         <img src="https://www.gartner.com/pi/vendorimages/surveysparrow_1722245657042.png" alt="Profile" className="profile-image" />
//         <button className="edit-button">
//           <FaEdit />
//         </button>
//       </div>

//       <h2 className="profile-name">{profileData.businesses[0]?.companyName || 'No Company Name'}</h2>
//       <p className="profile-birthday">{new Date(profileData.businesses[0]?.startDate).toLocaleDateString() || 'N/A'}</p>
//       <hr/>

//     <div className="profile-details">
//         <p className='mb-3'>
//           <MdAdminPanelSettings size={20} className="icon" /> {profileData.businesses[0]?.name || 'No name'}
//         </p>
//         <p className='mb-3'>
//           <FaEnvelope className="icon" /> {profileData.businesses[0]?.email || 'No email'}
//         </p>
//         <p className='mb-3'>
//           <FaPhoneAlt className="icon" />{profileData.businesses[0]?.mobileNo || 'No number'}
//         </p>
//         <p className='mb-3'>
//           <FaMapMarkerAlt className="icon" /> {profileData.businesses[0]?.location || 'No location'}
//         </p>
//         </div>
//         <hr/>
//         <div className="profile-details">
//         <p className="mb-3">
//         <MdSubscriptions className="icon" /> <strong>Subscription</strong> :{' '}
//         {subscriptionData.subscriptionplan?.title || 'N/A'}
//       </p>
//       <p className="mb-3">
//         <IoIosTime className="icon" /> <strong>Credits allotted</strong> :{' '}
//         {creditpoints}
//       </p>
//         <p className='mb-3'>
//           <PiContactlessPaymentFill className="icon" /> <strong>Payment method</strong>  : Net Banking
//         </p>
//         </div>
//     </div>
//            </div>
//         </Col>

//         <Col md={8}>
//           <div>
//           <div style={{ display:'flex', justifyContent: 'center', gap:'16px' }}>
//          <Card title="Subscription" extra={<PiDotsThreeBold size={20} style={{cursor:'pointer'}}/>}
//           style={{ width: '100%', }}>
//             <div className="premium-container">
//               <div className="premium-text">
//                 <h5 className="premium-title">
//                   <FaCrown className="crown-icon" /> Premium
//                 </h5>
//                 <span className="monthly-plan">Monthly plan</span>
//               </div>
//               <Button color="primary" variant="outlined">Upgrade Plan</Button>
//             </div>
//             <div className='mt-2'>
//               <p className='mb-0'>Active until Dec, 12 2025</p>
//               <span style={{color:'#747474', fontSize:'smaller'}}>We will send you a notification upon subscription expiry</span>
//               <p className='mb-0 mt-3'>₹ 7,999 Per Month</p>
//               <span style={{color:'#747474', fontSize:'smaller'}}>Extend your Pro package to 1,000+ leads</span>
//             </div>
//           </Card>
//             <Card title="Days Remaining" extra={<PiDotsThreeBold size={20} style={{cursor:'pointer'}}/>}
//           style={{ width: '100%',  }}>
//             <RemainingDays  creditpoints={creditpoints} availableAmount={AvailableAmount}  />
//         </Card>
//             </div>
//           </div>

//           <div className='mt-3'>
//             <Card title="Subscription transaction history" >
//               <TrancationTable />
//             </Card>
//           </div>
//         </Col>
//        </Row>
//     </div>
//   )
// }

// export default MyProfile
